import { axiosClient } from "../axiosClient";

export const twilio = {
  getConversations: async (params?: {
    limit?: number;
    includeMessages?: boolean;
    messageLimit?: number;
  }) => {

    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value.toString());
        }
      });
    }

    const fullUrl = queryParams.toString()
      ? `/portal/admin/twilio/conversations?${queryParams.toString()}`
      : "/portal/admin/twilio/conversations";

    return await axiosClient.get(fullUrl);
  },

  getConversationDetails: async (
    conversationSid: string,
    params?: {
      includeDeliveryReceipts?: boolean;
      messageLimit?: number;
    }
  ) => {

    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value.toString());
        }
      });
    }

    const fullUrl = queryParams.toString()
      ? `/portal/admin/twilio/conversations/${conversationSid}?${queryParams.toString()}`
      : `/portal/admin/twilio/conversations/${conversationSid}`;

    return await axiosClient.get(fullUrl);
  },

  clearConversation: async (conversationSid: string, reason?: string) => {
    return await axiosClient.post("/portal/admin/twilio/clear-conversation", {
      conversationSid,
      reason,
    });
  },

  closeConversation: async (conversationSid: string, reason?: string) => {
    return await axiosClient.post("/portal/admin/twilio/close-conversation", {
      conversationSid,
      reason,
    });
  },

  sendMessage: async (params: {
    conversationSid: string;
    body: string;
    author?: string;
  }) => {
    return await axiosClient.post(
      `/portal/admin/twilio/conversations/${params.conversationSid}/messages`,
      {
        body: params.body,
        author: params.author,
      }
    );
  },

  updateConversationState: async (
    conversationSid: string,
    state: "active" | "closed"
  ) => {
    return await axiosClient.patch(
      `/portal/admin/twilio/conversations/${conversationSid}`,
      { state }
    );
  },

  clearAgentCache: async (conversationSid?: string) => {
    return await axiosClient.post("/portal/admin/twilio/clear-agent-cache", {
      conversationSid,
    });
  },
};
